const STORAGE_KEY = 'abilitySuiteAttemptId';

/**
 * Current ability-suite attempt id, or null before the first restart/new tagged session.
 * @returns {string | null}
 */
export function getAbilitySuiteAttemptId() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Create a new attempt id (restart / retake) and persist it.
 * @returns {string}
 */
export function startNewAbilitySuiteAttempt() {
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `attempt-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore quota errors */
  }
  return id;
}

/**
 * Ensure an attempt id exists for tagging new progress/submissions.
 * @returns {string}
 */
export function ensureAbilitySuiteAttemptId() {
  const existing = getAbilitySuiteAttemptId();
  if (existing) return existing;
  return startNewAbilitySuiteAttempt();
}

/**
 * Keep progress rows that belong to the active attempt (legacy rows have no attemptId).
 * @param {object[]} list
 * @param {string | null} attemptId
 */
export function filterProgressByAttemptId(list, attemptId) {
  if (!attemptId) {
    return (list || []).filter((row) => !row?.attemptId);
  }
  return (list || []).filter((row) => row?.attemptId === attemptId);
}
